'use client';

import { ProductActions } from '@eliadmin/core/src/components/product/detail/product-actions';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';

/**
 * Ask / watchdog / share row (`show_actions`) under the delivery box. The design has no
 * classifications block (category and codes); the code sits in the heading row.
 */
export function ProductSecondaryActions() {
  const showActions = useGlobalStore(
    state => !!state.templateSettings.product_detail?.show_actions?.enabled,
  );

  return showActions ? <ProductActions /> : null;
}
